import { TrackerType } from '@futrli/shared-services';

import { injector } from './injector';

export const getTracker = () => {
  return injector.get<TrackerType>('Tracker');
};
